import { render, staticRenderFns } from "./CoursewareActivitiesWidgetFilterType.vue?vue&type=template&id=426cc9e2&"
import script from "./CoursewareActivitiesWidgetFilterType.vue?vue&type=script&lang=js&"
export * from "./CoursewareActivitiesWidgetFilterType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports